import { render, staticRenderFns } from "./ActiveEmail.vue?vue&type=template&id=38a00e28&scoped=true"
import script from "./ActiveEmail.vue?vue&type=script&lang=js"
export * from "./ActiveEmail.vue?vue&type=script&lang=js"
import style0 from "./ActiveEmail.vue?vue&type=style&index=0&id=38a00e28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a00e28",
  null
  
)

export default component.exports